<div class="_chart-component">

	<div class="_chart-container" [ngClass]="{'_has-legend': canToggleLegend}">
		<canvas baseChart
			*ngIf="type.pie"
			[datasets]="$any(data)"
			[labels]="labels"
			[type]="'pie'"
			[options]="chartOptions"
			[plugins]="chartPlugins"
		></canvas>
		<canvas baseChart
			*ngIf="type.bar"
			[datasets]="$any(data)"
			[labels]="labels"
			[type]="chartType"
			[options]="chartOptions"
			[plugins]="chartPlugins"
		></canvas>
		<canvas baseChart
			*ngIf="type.line"
			[datasets]="$any(data)"
			[labels]="labels"
			[type]="chartType"
			[options]="chartOptions"
			[plugins]="chartPlugins"
		></canvas>
		<div class="_legend-options">
			<div class="_legend-toggle" *ngIf="canToggleLegend">
				<ion-toggle (ionChange)="toggleLegend()" [checked]="chartOptions.plugins.legend.display"></ion-toggle>
				<p class="_toggle-label" [translate]="'LEGEND'"></p>
			</div>
			<div class="_legend-items-toggle">
				<button class="_button" (click)="toggleAllLegendItems()" *ngIf="canToggleLegendItems"  [ngClass]="{'_on':!legendItemsAreOff, '_off':legendItemsAreOff}">
					<span *ngIf="!legendItemsAreOff" [translate]="'LEGEND_ITEMS.ON'"></span>
					<span *ngIf="legendItemsAreOff" [translate]="'LEGEND_ITEMS.OFF'"></span>
				</button>
			</div>
		</div>
		
	</div>
	
</div>
